<template>
  <div class="ai-block"
       v-if="project && company.week_markup">
    <section class="ai-widget">
      <div @click.prevent="open=!open" class="compact-bar pointer">
        <div class="compact-title">
          <span class="ai-logo" aria-hidden="true">AI</span>
          <div>
            <h1>AI аналитика отзывов</h1>
            <p>{{ company.week_markup.period.from }} - {{ company.week_markup.period.to }}</p>
            <p class="analysis-count">Проанализировано
              {{ $pluralise(company.week_markup.total, ["отзыв", "отзыва", "отзывов"]) }} </p>
          </div>
        </div>
        <span class="insight-strip" aria-label="Краткие инсайты">
          <span v-for="insight in company.week_markup.insights"
                :class="'mini-insight mini-insight--'+insight.priority_level">
            <span class="mini-insight__evidence">Основано на {{
                $pluralise(insight.record_count, ["отзыв", "отзыва", "отзывов"])
              }} отзывов из {{ company.week_markup.total }} ({{ insight.percent }}%)</span>
            <strong>{{ levels[insight.priority_level] }}</strong>
            <span>{{ insight.title }}</span>
          </span>
         </span>
        <span class="expand-control" v-if="open"><span class="expand-label">Свернуть</span><span class="expand-icon"><i
            class="bi bi-chevron-up"></i></span></span>
        <span class="expand-control" v-else><span class="expand-label">Развернуть</span><span class="expand-icon"><i
            class="bi bi-chevron-down"></i></span></span>
      </div>
      <div class="expanded-panel" v-if="open">
        <div class="ai-content">
          <section class="insights grid" aria-labelledby="insights-title">
            <div class="section-head"><h2 id="insights-title">Ключевые инсайты</h2></div>
            <div class="column-title"><h3>Негативные инсайты</h3><span>Критичные и высокие риски</span></div>
            <div class="insight-columns">
              <div class="column">

                <article v-for="(insight, index) in company.week_markup.insights"
                         :class="'insight-card insight-card--'+(!index?'main':insight.priority_level)">
                  <div class="card-top">
                    <div class="card-badges">
                      <span :class="'tag tag--'+insight.priority_level">{{ levels[insight.priority_level] }}</span>
                      <span class="evidence-chip">Основано на {{
                          $pluralise(insight.record_count, ["отзыв", "отзыва", "отзывов"])
                        }} отзывов из {{ company.week_markup.total }} ({{ insight.percent }}%)</span>
                    </div>
                    <router-link class="btn btn-sm btn-outline-dark filter-button" target="_blank"
                       @click="goToReview(insight.title, insight.all_evidence_review_ids)"
                       :to="{name: 'project_reviews'}">
            Показать отзывы
          </router-link>
                  </div>
                  <h4>{{ insight.title }}</h4>
                  <p class="reason">{{ insight.details }}</p>
                  <ul class="theses" v-if="insight.short_meanings">
                    <li v-for="meaning in insight.short_meanings">{{ meaning }}</li>
                  </ul>
                  <div class="meta-line">
                    <span v-if="insight.tags.length">Темы: {{ insight.tags.join(",") }}</span>
                    <span
                        v-if="insight.dominant_products.length">Продукты: {{
                        insight.dominant_products.join(",")
                      }}</span>
                    <span
                        v-if="insight.dominant_channels.length">Площадки: {{
                        insight.dominant_channels.join(",")
                      }}</span>
                  </div>
                  <template v-if="insight.data_to_collect.length || insight.what_to_check.length">
                    <h5>Рекомендации</h5>
                    <template v-if="insight.what_to_check.length">
                      <p><b>Что проверить</b></p>
                      <ul>
                        <li v-for="check in insight.what_to_check">{{ check }}</li>
                      </ul>
                    </template>
                    <template v-if="insight.data_to_collect.length">
                      <p><b>Какие данные собрать</b></p>
                      <ul>
                        <li v-for="check in insight.data_to_collect">{{ check }}</li>
                      </ul>
                    </template>
                  </template>

                </article>
              </div>

            </div>
          </section>
        </div>
      </div>
    </section>

  </div>

</template>

<script>

import {AnalyticsApi} from "@/api/analytics";
import datesMixin from "@/mixins/filterDates";

export default {
  name: 'AnalyticData.vue',
  mixins: [datesMixin],
  props: {},
  data() {
    return {
      open: false,
      company: {},
      levels: {
        high: "Высокий",
        medium: "Средний",
        low: "Низкий",
      }
    }
  },
  watch: {},
  mounted: function () {
    let filters = {}
    filters.date_after = this.date_from
    filters.date_before = this.date_to
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value === null || value === undefined) {
        continue;
      }
      searchParams.append(key, value);
    }
    const queryString = searchParams.toString();
    AnalyticsApi.dictionary(queryString).then(response => {
      this.company = response;
    })

  },
  computed: {
    project: {
      get() {
        return this.$store.getters.currentProject
      }
    }

  },

  methods: {
    goToReview(name, ids) {
      localStorage.setItem(`pendingReviewIds_${this.project.id}`, JSON.stringify({name: name, ids: ids}))
    },
  }
}

</script>
<style scoped lang="scss">
.ai-block {
  // Переменные
  --bg: #f3f6fb;
  --surface: #fff;
  --surface-soft: #f8fafc;
  --text: #1f2937;
  --muted: #667085;
  --border: #e2e8f0;
  --border-strong: #cbd5e1;
  --red: #b0341a;
  --red-soft: #fbe8e4;
  --yellow: #d08700;
  --amber: #a66300;
  --blue: #2563eb;
  --blue-soft: #eaf3ff;
  --green: #15803d;
  --green-soft: #dcfce7;
  --radius: 8px;

  // Виджет AI
  .ai-widget {
    margin: 0 auto;
    border: 1px solid var(--border);
    border-radius: 8px;
    background: var(--surface);
    box-shadow: 0 8px 24px rgba(20, 39, 70, 0.08), 0 1px 4px rgba(20, 39, 70, 0.08);
    overflow: hidden;

    // Компактная панель
    .compact-bar {
      display: grid;
      grid-template-columns: minmax(220px, 0.58fr) minmax(0, 2fr) auto;
      gap: 14px;
      align-items: stretch;
      width: 100%;
      border: 0;
      padding: 14px 16px;
      background: linear-gradient(90deg, rgba(37, 99, 235, 0.08), rgba(37, 99, 235, 0)), var(--surface);
      color: inherit;
      text-align: left;
      cursor: pointer;

      .compact-title {
        display: flex;
        gap: 12px;
        align-items: center;
        min-width: 0;

        .ai-logo {
          display: inline-grid;
          width: 38px;
          height: 38px;
          place-items: center;
          border-radius: 9px;
          background: var(--blue);
          color: #fff;
          font-weight: 800;
        }

        p {
          color: var(--muted);
          font-size: 13px;
          margin: 0;
        }

        .analysis-count {
          margin-top: 2px;
          font-weight: 700;
          color: var(--text) !important;
        }
      }

      .insight-strip {
        display: grid;
        grid-template-columns: repeat(5, minmax(130px, 1fr));
        gap: 8px;
        min-width: 0;
        align-items: stretch;

        .mini-insight {
          display: flex;
          flex-direction: column;
          min-width: 0;
          border: 1px solid var(--border);
          border-left: 4px solid var(--red);
          border-radius: 8px;
          background: #fff;
          padding: 9px 10px;

          &--high {
            border-left-color: var(--red);
          }

          &--medium {
            border-left-color: var(--yellow);
          }

          &--low {
            border-left-color: var(--border-strong);
          }

          &--positive {
            border-left-color: #20b970;
            background: var(--green-soft);
          }

          strong {
            display: block;
            margin-bottom: 3px;
            font-size: 12px;
            line-height: 1;
            color: var(--red);
            white-space: nowrap;
          }

          &--medium strong {
            color: var(--amber);
          }

          &--low strong {
            color: var(--muted);
          }

          &--positive strong {
            color: var(--green);
          }

          span {
            display: block;
            color: var(--text);
            font-size: 13px;
            font-weight: 700;
            line-height: 1.28;
            white-space: normal;
          }

          .mini-insight__evidence {
            margin-bottom: 5px;
            color: var(--muted);
            font-size: 12px;
            font-weight: 700;
            line-height: 1.2;
          }
        }
      }

      .expand-control {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        justify-content: center;
        min-height: 38px;
        border: 1px solid #bed8ff;
        border-radius: 8px;
        background: #eaf3ff;
        color: #0b5ed7;
        font-weight: 800;
        padding: 8px 12px;
        white-space: nowrap;
        align-self: center;
        width: 143px;

        .expand-icon {
          transition: transform 160ms ease;
        }
      }
    }

    // Состояние expanded
    &.is-expanded {
      .expand-icon {
        transform: rotate(180deg);
      }

      .expanded-panel {
        display: block;
      }
    }

    // Развернутая панель
    .expanded-panel {
      border-top: 1px solid var(--border);

      .ai-block__header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 24px;
        padding: 20px 22px 18px;
        border-bottom: 1px solid var(--border);
        background: var(--surface);

        .ai-title {
          display: flex;
          gap: 14px;
          align-items: flex-start;
          min-width: 0;

          .ai-logo {
            width: 48px;
            height: 48px;
            flex-basis: 48px;
            font-size: 24px;
          }

          h2 {
            font-size: 24px;
            line-height: 1.2;
            margin-bottom: 5px;
          }
        }
      }

      .ai-content {
        display: grid;
        gap: 24px;
        padding: 22px;

        .section-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;

          h2 {
            font-size: 22px;
          }
        }

        .column-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          margin-bottom: 2px;

          h3 {
            font-size: 18px;
            line-height: 1.25;
          }

          span {
            color: var(--muted);
            font-size: 13px;
          }
        }

        .insight-columns {
          display: grid;

          width: 100%;
          gap: 16px;
          align-items: start;

          .column {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 10px;
            min-width: 0;


            .insight-card {
              border: 1px solid var(--border);
              border-radius: var(--radius);
              background: var(--surface);
              padding: 15px;

              &--main,
              &--critical,
              &--high {
                border-color: #f1b7bf;
                border-left: 5px solid var(--red);
              }

              &--main {
                background: var(--red-soft);
                padding: 18px;

                h4 {
                  font-size: 21px;
                  max-width: 980px;
                }
              }

              &--medium {
                border-color: #ffd58a;
                border-left: 5px solid var(--yellow);
              }

              &--low {
                border-left: 5px solid var(--border-strong);
              }

              &--positive {
                border-color: #a9e8c6;
                border-left: 5px solid #20b970;
                background: var(--green-soft);
              }

              h4 {
                font-size: 18px;
                line-height: 1.28;
                font-weight: bold;
              }

              h5 {
                margin-top: 15px;
              }

              .card-top {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                gap: 12px;
                margin-bottom: 10px;

                .card-badges {
                  display: flex;
                  align-items: center;
                  flex-wrap: wrap;
                  gap: 7px;
                  min-width: 0;

                  .tag {
                    display: inline-flex;
                    align-items: center;
                    min-height: 24px;
                    border-radius: 8px;
                    padding: 3px 8px;
                    font-weight: 800;
                    font-size: 13px;

                    &--critical,
                    &--high {
                      color: #fff;
                      background: var(--red);
                    }

                    &--medium {
                      color: var(--amber);
                      background: #fff7e8;
                      border: 1px solid #ffd58a;
                    }

                    &--low {
                      color: var(--muted);
                      background: var(--surface-soft);
                      border: 1px solid var(--border);
                    }

                    &--positive {
                      color: var(--green);
                      background: var(--green-soft);
                      border: 1px solid #a9e8c6;
                    }
                  }

                  .evidence-chip {
                    display: inline-flex;
                    min-height: 24px;
                    align-items: center;
                    border: 1px solid var(--border);
                    border-radius: 8px;
                    background: #fff;
                    color: var(--muted);
                    padding: 3px 8px;
                    font-size: 13px;
                  }

                  .filter-button {
                    appearance: none;
                    border: 1px solid #bed8ff;
                    border-radius: 8px;
                    color: #0b5ed7;
                    background: #fff;
                    cursor: default;
                    padding: 4px 8px;
                  }
                }
              }

              .reason {
                margin-top: 11px;
                color: #27364d;
              }

              .theses,
              .rec-list {
                display: grid;
                gap: 7px;
                margin: 12px 0 0;
                padding-left: 18px;
                color: #27364d;
              }

              .meta-line {
                display: flex;
                flex-wrap: wrap;
                gap: 7px;
                margin-top: 12px;
                color: var(--muted);
                font-size: 13px;

                span {
                  display: inline-flex;
                  min-height: 24px;
                  align-items: center;
                  border: 1px solid var(--border);
                  border-radius: 8px;
                  background: #fff;
                  padding: 3px 8px;
                }
              }
            }
          }
        }

        .recommendations {
          border-top: 1px solid var(--border);
          padding-top: 24px;

          .rec-grid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 12px;

            .rec-card {
              display: flex;
              flex-direction: column;
              min-height: 420px;
              border: 1px solid var(--border);
              border-top: 4px solid var(--blue);
              border-radius: var(--radius);
              background: var(--surface);
              padding: 15px;

              &--critical,
              &--high {
                border-top-color: var(--red);
              }

              &--medium {
                border-top-color: var(--yellow);
              }

              h3 {
                font-size: 18px;
                line-height: 1.25;
                margin-bottom: 9px;
              }

              p {
                color: #354156;
                font-size: 14px;
              }

              .rec-meta {
                display: flex;
                flex-wrap: wrap;
                gap: 7px;
                margin-bottom: 10px;

                span {
                  border: 1px solid var(--border);
                  border-radius: 8px;
                  background: var(--surface-soft);
                  color: var(--muted);
                  padding: 4px 8px;
                  font-size: 13px;
                }
              }

              .rec-section {
                margin-top: 14px;

                strong {
                  display: block;
                  margin-bottom: 5px;
                }
              }

              .linked-problem {
                margin-top: 12px;

                strong {
                  display: block;
                  margin-bottom: 5px;
                }
              }

              .risk {
                margin-top: 12px;
              }
            }
          }
        }
      }
    }
  }

  // Медиа-запросы
  @media (max-width: 1100px) {
    .ai-widget {
      .compact-bar {
        grid-template-columns: 1fr;

        .insight-strip {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
      }

      .expanded-panel {
        .ai-content {
          .recommendations {
            .rec-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }
          }
        }
      }
    }
  }

  @media (max-width: 760px) {
    .preview-page {
      padding: 12px;
    }

    .ai-widget {
      .compact-bar {
        .insight-strip {
          grid-template-columns: 1fr;
        }
      }

      .expanded-panel {
        .ai-content {
          padding: 16px;

          .insight-columns {
            grid-template-columns: 1fr;
          }

          .recommendations {
            .rec-grid {
              grid-template-columns: 1fr;
            }
          }
        }
      }
    }
  }
}
</style>
